<!-- Responsibility: Manage the preforge composer workspace.
Scope: Form rendering and workflow for realities. -->
<preforge-workspace-composer>
  <div class="workspace-composer">
    <div ref="host" class="workspace-host"></div>
  </div>

  <script>
    import { AutoForm, collectValues, populateFields } from 'field-assist'
    import {
      buildPreforgeReviewFormMeta,
      buildPreforgeReviewFormGroups,
      buildPreforgeReviewInitialValues,
      linkPreforgeFormLabels,
      setPreforgeFormLocked,
    } from '../../helpers/admin-preforge-form.ts'

    export default {
      onMounted() {
        this.render()
      },

      onUpdated() {
        if (this.props.mode !== this.lastMode || this.props.offerId !== this.lastOfferId) {
          this.render()
        }
      },

      render() {
        const { mode, offer, locked, brief } = this.props
        this.lastMode = mode
        this.lastOfferId = offer?.id
        
        const host = this.$('[ref="host"]')
        if (!(host instanceof HTMLElement)) return
        host.replaceChildren()

        if (mode === 'brief') {
          this.renderBrief(host, brief)
        } else {
          this.renderForm(host, offer, locked)
        }
      },

      renderBrief(host, brief) {
        host.dataset.preforgeStage = 'brief'
        const wrapper = document.createElement('section')
        wrapper.className = 'preforge-brief-panel'
        const label = document.createElement('label')
        label.className = 'preforge-brief-label'
        label.textContent = 'Plain-English Brief'
        const input = document.createElement('textarea')
        input.className = 'preforge-brief-input'
        input.rows = 10
        input.placeholder = 'Describe the world in plain English...'
        input.value = brief || ''
        wrapper.append(label, input)
        host.append(wrapper)
        input.addEventListener('input', () => this.props.onBriefInput(input.value))
        requestAnimationFrame(() => input.focus())
      },

      renderForm(host, offer, locked) {
        host.dataset.preforgeStage = 'form'
        const initialValues = buildPreforgeReviewInitialValues(offer || {})
        const autoForm = new AutoForm(buildPreforgeReviewFormMeta())
        autoForm.groups = buildPreforgeReviewFormGroups()
        autoForm.render(initialValues, host)
        populateFields(host, initialValues, 'name')
        linkPreforgeFormLabels(host)
        setPreforgeFormLocked(host, locked)
      },

      getValues() {
        const host = this.$('[ref="host"]')
        return collectValues(host, undefined, 'name')
      }
    }
  </script>

  <style>
    .workspace-host { display: grid; gap: var(--space-md); }
    .preforge-brief-panel { display: grid; gap: var(--space-xs); }
    .preforge-brief-label { font-size: 0.8rem; color: var(--text-muted); font-weight: bold; }
    .preforge-brief-input {
      background: var(--bg-deep);
      color: var(--text-prose);
      border: 1px solid var(--border);
      border-radius: 0.5rem;
      padding: var(--space-md);
      font-family: inherit;
      line-height: 1.6;
      resize: vertical;
    }
  </style>
</preforge-workspace-composer>
